module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box user-tb"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title pull-right"
  }, [_c('button', {
    staticClass: "btn primary-btn-my  clear-new-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.newModal = true
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show",
    attrs: {
      "md-active": _vm.newModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.newModal = $event
      },
      "update:md-active": function($event) {
        _vm.newModal = $event
      }
    }
  }, [_c('div', [_c('md-card', {
    staticClass: "md-layout-item"
  }, [_c('md-card-header', {
    staticClass: "box-shadow-popupHeader"
  }, [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Add Product\n            "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.newModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close")])], 1)])]), _vm._v(" "), _c('md-card-content', {
    staticClass: "md-scrollbar PopUpframe",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('form', {
    staticClass: "row-rm-padding"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClassNewForm('products')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Products")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "product",
      "id": "products"
    },
    model: {
      value: (_vm.newForm.products),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "products", $$v)
      },
      expression: "newForm.products"
    }
  }, _vm._l((_vm.productsSelection), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1), _vm._v(" "), (!_vm.$v.newForm.products.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Product is required")]) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('md-card-actions', {
    staticClass: "pd-18"
  }, [_c('sync-loader', {
    attrs: {
      "loading": _vm.newModalLoading,
      "color": _vm.newModalColor,
      "size": _vm.newModalSize,
      "width": _vm.newModalWidth,
      "margin": _vm.newModalMargin
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn primary-btn-my",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("\n            Add\n          ")])], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "tableData"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Date\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "24%"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Description\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "4%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Status\n                    ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558aa732"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserProductsView.vue
// module id = 2095
// module chunks = 1